/**
 * ページをまたいだアンカーリンク
 */
export class PageScroll {

  /**
   * windowオブジェクト
   */
  private readonly $window: JQuery;

  /**
   * ヘッダーオブジェクト
   */
  private readonly header: string;

  /**
   * ユーザーエージェント
   */
  private readonly ua: string;

  /**
   * コンストラクタ
   * @param header ヘッダー要素セレクタ
   */
  constructor(header: string = '.fn-header') {
    this.$window = $(window);
    this.header = header;
    this.ua = navigator.userAgent.toLowerCase();
    this.$window.on('load', this.loadListener);
  }

  /**
   * ロードイベントリスナー
   * @param event イベントオブジェクト
   */
  private loadListener = (event: JQueryEventObject): void => {
    let $target: JQuery | null = null;
    const href: string = location.href
    const hash: string = this.getQueryVariable('js-hash');

    if (href.indexOf('#') != -1) {
      try {
        $target = $('#' + href.split('#')[1]);
      } catch (e) {
        $target = null;
      }
    } else if (hash) {
      $target = $('#' + hash);
    }

    if ($target && $target[0]) {
      setTimeout((): void => {
        if ($target && $target[0]) {
          $('html, body').animate({scrollTop: $target.offset()!.top - $(this.header).height()}, 1);
        }
      }, 1000);
    }
  }

  /**
   * URLパラメータのクエリ値を取得
   * @param variable クエリ名
   * @returns クエリ値
   */
  private getQueryVariable(variable: string): string {
    const query: string = window.location.search.substring(1);
    const vars: string[] = query.split('&');

    for (let i: number = 0; i < vars.length; i++) {
      const pair: string[] = vars[i].split('=');

      if (pair[0] == variable) {
        return pair[1];
      }
    }

    return '';
  }

}
